
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/regions/[[...sections]]",
      function () {
        return require("private-next-pages/network/regions/[[...sections]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network/regions/[[...sections]]"])
      });
    }
  